var render, staticRenderFns
import script from "./indexDetail.vue?vue&type=script&lang=js"
export * from "./indexDetail.vue?vue&type=script&lang=js"
import style0 from "./indexDetail.vue?vue&type=style&index=0&id=08477e5c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08477e5c",
  null
  
)

export default component.exports